export function formatDateInput(value) {
    if (!value) {
        return '';
    }
    // Returns the YYYY-MM-DD part from the full ISO date format.
    return formatDateISO(value).substr(0, 10);
}
export function formatDateISO(value) {
    if (!value) {
        return '';
    }
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date.toISOString();
}
const DEFAULT_OPTIONS = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
};
export function formatDate(value, options = DEFAULT_OPTIONS) {
    if (!value) {
        return '';
    }
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    const formatter = new Intl.DateTimeFormat('en-GB', options);
    return formatter.format(date);
}
